import React from 'react';
import { motion } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Textarea } from '../ui/Textarea';
import { MascotPanel } from '../ui/MascotPanel';
export function Step14Planning() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-179">
      <MascotPanel message="De laatste stap voor de afronding! Laten we de planning en verwachtingen afstemmen." data-id="element-180" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-181">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-182">
          Planning & Workflow
        </h2>

        <div data-id="element-183">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-184">
            Wanneer wilt u de website idealiter live hebben?
          </label>
          <RadioGroup columns={2} value={data.launchDate} onChange={val => updateData({
          launchDate: val
        })} options={[{
          value: 'asap',
          label: 'Zo snel mogelijk'
        }, {
          value: '4to6weeks',
          label: 'Binnen 4 tot 6 weken'
        }, {
          value: '2to3months',
          label: 'Binnen 2-3 maanden'
        }, {
          value: 'relaxed',
          label: 'Geen haast, kwaliteit voorop'
        }]} data-id="element-185" />
        </div>

        <Textarea label="Zijn er nog andere belangrijke zaken, opmerkingen of vragen?" placeholder="Laat het ons hier weten..." value={data.remarks} onChange={e => updateData({
        remarks: e.target.value
      })} data-id="element-186" />

        <div className="pt-6 border-t border-gray-100" data-id="element-187">
          <Textarea label="Extra notities voor het ontwikkelteam" placeholder="Heeft u nog specifieke wensen, technische eisen, of andere informatie die belangrijk is voor het bouwen van uw website? Alles wat u hier schrijft wordt meegenomen in het ontwikkelproces." value={data.extraNotes} onChange={e => updateData({
          extraNotes: e.target.value
        })} className="min-h-[160px]" data-id="element-188" />
        </div>
      </div>
    </motion.div>;
}